export const CHARGER = "charger";
export const CHARGERS = "chargers";
